import React from 'react'

const SwitchPass = ({
	value,
	setValue,
}: {
	value: boolean
	setValue: (newValue: boolean) => void
}) => {
	const handleClick: React.MouseEventHandler<HTMLButtonElement> = () => {
		setValue(!value)
	}
	return (
		<button
			className={`toggle-button ${value ? 'on' : 'off'}`}
			onClick={handleClick}
		>
			<div className="toggle-button-inner">
				<div className="toggle-button-circle"></div>
			</div>
		</button>
	)
}

export default SwitchPass
